<template>
  <v-dialog v-model="storeSearchDialog" width="800">
    <customDialog>
      <template v-slot:title>
        {{t('selectRegion')}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img"
						@click="storeSearchDialog = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-2 pl-5 pr-5 pb-2" cols="12" id="store_list">
			  		<v-col class="ma-0" cols="auto"
							style="border-bottom: 1px solid #4A4A4A; padding-left:2.7rem;">
							<v-row class="ma-0 pa-0" align="center">
								<input id="check_box" type="checkbox" 
									v-model="area.allSelect" v-on:change="selecteAllArea"/>
								<v-col class="ma-0 pa-0 ml-3" cols="auto">{{'すべての店舗' + ' (' + storeTotal + ')'}}</v-col>
							</v-row>
						</v-col>
            <v-col class="ma-0 pa-0">
              <v-treeview class="ma-0 pa-0" selected-color="blue"
						  	selectable dark dense v-model="selectedRegions"
						  	:items="area.regions" item-key="id">
						  	<template v-slot:label="{item}">
                  <v-col class="ma-0 pa-0" cols="auto">
						  			{{item.id + ' (' + item.value.length + ')'}}
						  		</v-col>
						  	</template>
						  </v-treeview>
            </v-col>
				  </v-col>
					<v-col class="ma-0 pa-0 mt-5 mb-2" cols="12">
						<v-row class="ma-0 pa-0" align="center" justify="center">
							<v-btn width="8rem" height="auto" class="ma-0 pa-2" 
								id="grey_btn" elevation="0" @click="reset">
								{{t('reset')}}
							</v-btn>
              <v-btn width="8rem" height="auto" class="ma-0 pa-2 ml-2" 
								id="grey_btn" elevation="0" @click="storeSearchDialog = false">
								{{t('cancel')}}
							</v-btn>
							<v-btn width="8rem" height="auto" class="ma-0 pa-2 ml-2" 
								id="blue_btn" elevation="0" @click="editArea">
								{{t('confirm')}}
							</v-btn>
						</v-row>
					</v-col>
        </v-row>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';
export default {
  props: {
    dialogVisible: Boolean,
    // 지역 목록을 만들 점포 데이터. 미전달(null)이면 기존처럼 store-search 결과(getStoreSearchResult) 사용.
    storeData: { type: Array, default: null },
    // 초기 선택 지역(areaName 배열). 미전달(null)이면 기존처럼 searchCondition.selectedAreas 사용.
    preSelectedAreas: { type: Array, default: null }
  },
  components: {
    customDialog
  },
  mixins: [mixin.common],
  data: () => ({
    storeSearchDialog: false,
		area: {},
		storeList: [],
		storeTotal: 0,
    selectedRegions: [],
  }),
  watch: {
    dialogVisible: function(item) {
      this.storeSearchDialog = item;
    },
    storeSearchDialog: function(item) {
      this.$emit('visible', item);
			if(item == true) {
				this.storeList = this.storeData != null ? this.storeData : this.$store.getters.getStoreSearchResult;
				let searchCondition = this.$store.getters.getSearchCondition;
				this.selectedRegions = this.preSelectedAreas != null
					? this.preSelectedAreas
					: searchCondition.selectedAreas;
				this.storeTotal = this.storeList.length;
				let group1 = this.groupBy(this.storeList, data => data.unisCustomerPref)
				group1.forEach((item, index) => {
					let group2 = this.groupBy(item.value, data => data.areaName)
					group1[index].children = group2
				})
				this.area.regions = group1;
			}
    },
		selectedRegions: function(item) {
			console.log('%cselectedRegions\n', "color:#008DD0;", item);
		},
  },
  created() {

  },
  methods: {
		reset() {
			let searchCondition = this.$store.getters.getSearchCondition;
			this.selectedRegions = this.preSelectedAreas != null
				? this.preSelectedAreas
				: searchCondition.selectedAreas;
		},
		selecteAllArea() {
      if(this.area.allSelect) {
				this.selectedRegions = [];
				this.area.regions.forEach((region) => {
					region.children.forEach((item) => {
						this.selectedRegions.push(item.id);
					});
				});
			} else {
				this.selectedRegions = [];
			}
    },
		groupBy(list, keyGetter) {
			const map = new Map();
			list.forEach((item) => {
				const key = keyGetter(item);
				const collection = map.get(key);
				if (!collection) {
					map.set(key, [item]);
				} else {
					collection.push(item);
				}
			});
			return Array.from(map, ([id, value]) => ({ id, value }));
		},
		editArea() {
			this.storeSearchDialog = false;
			this.$emit('editArea', this.selectedRegions);
		},
  }
}
</script>

<style lang="scss" scoped>

::v-deep {
	.v-treeview--dense .v-treeview-node__root { //트리뷰
		border-bottom: 1px solid #4A4A4A;
	}
	.v-treeview-node__children { //트리뷰(아이템 가로 정렬)
		display: flex;
		flex-wrap: wrap;
		.v-treeview-node__root {
			border-bottom: none;
		}
		.v-treeview-node.v-treeview-node--leaf {
			width: 13em;
		}
	}
	.v-treeview-node__checkbox { // 트리뷰 체크박스 CSS
		background-color: white;
		border-radius: 5px;
		width: 18px;
		height: 18px;
		margin-left: 8px;
		margin-right: 5px;
	}
}
#store_list {
	overflow: auto;
	min-height: 350px;
	max-height: 350px;
  text-align: left;
  color: white;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
</style>